import { useEffect, useRef } from "react";
import { Tooltip } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { debounce } from "lodash";

import { GetUrlParams, ObjectToURL } from "scripts/helpers";
import { Modals } from "scripts/settings";
import Icons from "scripts/icons";
import Resources from "scripts/resources";
import API from "scripts/api";

import Logo from "images/logo.png";

const Component = ({ cities, user }) => {
	const location = useLocation();
	const navigate = useNavigate();
	const inputRef = useRef();
	const { category, sortBy, search } = GetUrlParams(location.search);
	const token = API.getCookie(process.env.REACT_APP_COOKIE_TOKEN);

	const handleChange = debounce((e) => {
		const query = ObjectToURL({ category, sortBy, search: e.target.value });

		navigate({ pathname: "/jobs", search: `?${query}` });
	}, 1000);

	const componentDidUpdate = () => {
		inputRef.current.value = search || "";
	};

	useEffect(componentDidUpdate, [location.search]);

	return (
		<div className="spa-header">
			<div className="container">
				<Tooltip title={Resources.home}>
					<Link className="logo" to="/">
						<img src={Logo} alt={Resources.bakelid} />
					</Link>
				</Tooltip>
				<Link to={`${location.search}#${Modals.LOCATION}`} className="location">
					{`${cities.length} ${Resources.city}`}
					<Icons.Location />
				</Link>
				<input
					type="search"
					className="search"
					placeholder={`${Resources.search}`}
					onChange={handleChange}
					ref={inputRef}
				/>
				<Tooltip title={Resources.category}>
					<Link to={`${location.search}#${Modals.CATEGORY}`} className="filter">
						<Icons.Category />
					</Link>
				</Tooltip>
				<Tooltip title={Resources.sort}>
					<Link to={`${location.search}#${Modals.SORT}`} className="filter">
						<Icons.Sort />
					</Link>
				</Tooltip>
				{location.pathname === "/jobs" && false && (
					<Link to={`#${Modals.SORT}`} className="filter">
						<Icons.Sort />
					</Link>
				)}
				<Tooltip title={`${Resources.around} ${Resources.i}`}>
					<Link to={`${location.search}#${Modals.AROUND}`} className="filter">
						<Icons.Discover />
					</Link>
				</Tooltip>
				{token ? (
					<>
						<Tooltip title={Resources.account}>
							<Link to="/panel" className="profile">
								{user?.unreadNotificationsCount > 0 ? (
									<span className="badge">
										{user?.unreadNotificationsCount}
									</span>
								) : (
									""
								)}
								<Icons.Frame />
							</Link>
						</Tooltip>
						<Tooltip title={Resources.notifications}>
							<Link to="/panel/notifications" className="notification">
								<Icons.Notification />
							</Link>
						</Tooltip>
					</>
				) : (
					<Tooltip title={`${Resources.enter} / ${Resources.register}`}>
						<Link to="/auth/status" className="login">
							{`${Resources.register} / ${Resources.enter}`}
							<Icons.Frame />
						</Link>
					</Tooltip>
				)}
			</div>
		</div>
	);
};

export default connect((state) => {
	return {
		cities: state.configs?.cities || [],
		user: state.user,
	};
})(Component);
